// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__g1usB","comment":"styles_comment__3HgbE"};